// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7ae1d1f5","693":"b215f07c","755":"48eae64e","845":"5cbcdef7","910":"fbe38ea1"}[chunkId] + ".chunk.js";
};